"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserExternalWallets = exports.UserExternalWalletsProvider = void 0;
var axios_1 = __importDefault(require("axios"));
var constate_1 = __importDefault(require("constate"));
var react_1 = require("react");
var store2_1 = __importDefault(require("store2"));
var _shared_1 = require("../shared");
var utils_1 = require("../wallets/utils");
var EXPIRATION = 3600 * 1000;
function useUserExternalWalletsRaw(_a) {
    var _this = this;
    var getWallets = _a.getWallets, fetch = _a.fetch;
    var account = (0, _shared_1.useUser)().account;
    var web3 = (0, _shared_1.useWeb3Provider)().web3;
    var _b = (0, react_1.useState)({}), wallets = _b[0], setWallets = _b[1];
    var _c = (0, react_1.useState)(false), isChanging = _c[0], setIsChanging = _c[1];
    var key = "".concat(account, "-external");
    (0, react_1.useEffect)(function () {
        if (!fetch || !account)
            return;
        var _a = store2_1.default.get(key, { cached: '', expiresAt: 0 }), cached = _a.cached, expiresAt = _a.expiresAt;
        if (cached && Date.now() < expiresAt) {
            setWallets(cached);
            return;
        }
        getWallets(account)
            .then(function (value) {
            setWallets(value || {});
            if (value) {
                store2_1.default.set(key, { cached: value, expiresAt: Date.now() + EXPIRATION });
            }
        })
            .catch(function (e) { return console.error('Failed to get external wallets', e); });
    }, [account, fetch, key]);
    var update = (0, react_1.useCallback)(function (address, network) { return __awaiter(_this, void 0, void 0, function () {
        var signature;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!utils_1.validators[network](address))
                        return [2 /*return*/];
                    return [4 /*yield*/, web3.eth.personal.sign(web3.utils.fromUtf8((0, utils_1.getMessageToSign)(address, network)), account, 'pass')];
                case 1:
                    signature = _a.sent();
                    return [2 /*return*/, axios_1.default
                            .post("/api/user?account=".concat(account), {
                            walletAddress: address,
                            walletNetwork: network,
                            signature: signature,
                        })
                            .then(function () {
                            setWallets(function (oldWallets) {
                                var _a;
                                var newWallets = __assign(__assign({}, oldWallets), (_a = {}, _a[network] = address, _a));
                                store2_1.default.set(key, {
                                    cached: newWallets,
                                    expiresAt: Date.now() + EXPIRATION,
                                });
                                return newWallets;
                            });
                            setIsChanging(false);
                            return true;
                        })
                            .catch(function (e) {
                            console.error('Failed to update extra wallet', e);
                            return false;
                        })];
            }
        });
    }); }, [account, web3, key]);
    return {
        wallets: wallets,
        update: update,
        toggleChanging: function (status) {
            return setIsChanging(status === undefined ? !isChanging : status);
        },
        isChanging: isChanging,
    };
}
exports.UserExternalWalletsProvider = (_a = (0, constate_1.default)(useUserExternalWalletsRaw), _a[0]), exports.useUserExternalWallets = _a[1];
